import { resolve } from 'acast-www-utils';

const isFunction = v => typeof v === 'function';
const isObject = v => Object(v) === v;
const isString = v => typeof v === 'string';

function getPropsDescriptor(key, value) {
  const descriptor = {};
  const isKeyFunction = isFunction(key);
  const isKeyObject = isObject(key);
  const isKeyString = isString(key);
  const isValueString = isString(value);

  if (isKeyFunction || isKeyObject) {
    descriptor.props = key;
  } else if (isKeyString) {
    descriptor.props = props => ({
      [key]: isValueString ? resolve(props, value, value) : value,
    });
  }

  return descriptor;
}

function getQueryDescriptor(key, value) {
  const descriptor = {};
  const isKeyString = isString(key);
  const isValueFunction = isFunction(value);
  const isValueObject = isObject(value);

  if (!isKeyString) {
    if (isValueFunction) {
      descriptor.query = value;
    } else if (isValueObject) {
      const objectContainesQueryKey = 'query' in value;

      if (objectContainesQueryKey) {
        descriptor.query = value.query;
      } else {
        descriptor.query = value;
      }
    }
  }

  return descriptor;
}

export default function getDescriptor([key, value]) {
  const descriptor = {};

  Object.assign(descriptor, getPropsDescriptor(key, value));
  Object.assign(descriptor, getQueryDescriptor(key, value));

  return descriptor;
}
